import React from 'react';

// Function to convert seconds to hours, minutes, and seconds
const convertSecondsToHM = (seconds) => {
  const hours = Math.floor(seconds / 3600); // Get hours
  const minutes = Math.floor((seconds % 3600) / 60); // Get minutes
  const secs = seconds % 60; // Get remaining seconds

  // Format the time as a string with labels
  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: secs.toString().padStart(2, '0'),
  };
};

export default function Overview({ users, booksPerLanguage, totalBooksPlayed, totalPlayTime, message }) {
  const totalUsers = users.length;

  const totalBooks = booksPerLanguage.reduce((sum, item) => sum + item.totalBooks, 0);

  const languageBooks = booksPerLanguage.reduce((acc, item) => {
    const language = item._id;
    if (acc[language]) {
      acc[language] += item.totalBooks;
    } else {
      acc[language] = item.totalBooks;
    }
    return acc;
  }, {});

  // Convert totalPlayTime to hours, minutes, and seconds
  const { hours, minutes, seconds } = convertSecondsToHM(totalPlayTime);

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-8">
          <div className="row">
            <div className="col-md-6 py-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Total Users</h5>
                  <p className="card-text">{totalUsers}</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Total Books</h5>
                  <p className="card-text">{totalBooks}</p>
                </div>
              </div>
            </div>

            {/* Total Books Played This Month Card */}
            <div className="col-md-6 py-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Total Books Played This Month</h5>
                  <p className="card-text">{totalBooksPlayed}</p>
                </div>
              </div>
            </div>

            {/* Total Play Time This Month Card */}
            <div className="col-md-6 py-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Total Play Time This Month</h5>
                  <p className="card-text">
                    {hours} Hours {minutes} Minutes {seconds} Seconds
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4 py-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Total Books per Language</h5>
              <ul className="list-group list-group-flush">
                {Object.entries(languageBooks).map(([language, totalBooks]) => (
                  <li key={language} className="list-group-item">
                    {language.charAt(0).toUpperCase() + language.slice(1)}: {totalBooks}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
